module.exports = __webpack_public_path__ + "img/rotate.8c344de9.svg";